import type { EmojiPluginOptions } from '@atlaskit/editor-plugin-emoji';
import type { EmojiProvider } from '@atlaskit/emoji';

interface Props {
	options: never;
	providers: {
		emojiProvider: Promise<EmojiProvider> | undefined;
	};
}

export function emojiPluginOptions({ providers }: Props): EmojiPluginOptions {
	return {
		emojiProvider: providers.emojiProvider,
	};
}
